module.exports = __webpack_public_path__ + "static/media/c5.95b4ac10.gif";